import PatientScriptInfo  from "../../../global/view/patient-script-infoForm";

export default function PatientScriptInfoFull() {
  return <PatientScriptInfo />;
}